import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { ENTITY_TYPE } from "../../constants/phase";
import { getEntityType } from "../../helpers";
import { getEntityConfig } from "../entityConfig/actions";

export const workspaceConfigEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity.workspaceId,
});

const initialState = workspaceConfigEntityAdapter.getInitialState({});

export const workspaceConfigSlice = createSlice({
  name: "workspaceConfig",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getEntityConfig.fulfilled, (state, action) => {
      if (getEntityType(action.meta.arg.entityId) === ENTITY_TYPE.WORKSPACES && action.payload.status) {
        workspaceConfigEntityAdapter.upsertOne(state, action.payload.data);
      }
    });
  },
});

export default workspaceConfigSlice.reducer;
